<template>
	<div class="message-attachments" v-if="attachments && attachments.length > 0">
		<div class="attachments-list">
			<div v-for="(attachment, index) in attachments" :key="index" class="attachment-item" :class="{ 'is-image': isImage(attachment) }">
				<!-- Image attachment -->
				<div v-if="isImage(attachment)" class="image-attachment" @click="previewImage(attachment)">
					<img :src="getImageUrl(attachment)" :alt="attachment.name" class="attachment-image" />
				</div>

				<!-- File attachment -->
				<div v-else class="file-attachment">
					<div class="file-icon">
						<InlineSvg :src="getFileIcon(attachment)" />
					</div>
					<div class="file-info">
						<div class="file-name">{{ attachment.name }}</div>
						<div class="file-type">{{ getFileType(attachment) }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'MessageAttachments',
		props: {
			attachments: {
				type: Array,
				default: () => [],
			},
		},
		methods: {
			isImage(file) {
				return file.type.startsWith('image/')
			},
			getImageUrl(file) {
				return URL.createObjectURL(file)
			},
			getFileIcon() {
				return '/images/icons-2025/file.svg'
			},
			getFileType(file) {
				// Extract file extension or type
				const extension = file.name
					.split('.')
					.pop()
					.toUpperCase()
				return extension || file.type.split('/')[1]?.toUpperCase() || 'FILE'
			},
			previewImage(attachment) {
				this.$emit('preview-image', attachment)
			},
		},
	}
</script>

<style lang="scss" scoped>
	.message-attachments {
		margin-top: 8px;
	}

	.attachments-list {
		display: flex;
		flex-direction: column;
		gap: 8px;
		align-items: flex-end;
	}

	.attachment-item {
		&.is-image {
			.image-attachment {
				cursor: pointer;
				border-radius: 8px;
				overflow: hidden;
				border: 1px solid #e9ecff;
				width: auto;
				max-width: 120px;

				.attachment-image {
					height: auto;
					display: block;
				}
			}
		}

		.file-attachment {
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 7px;
			border-radius: 10px;
			background: #ffffff;
			border: 1px solid #e9ecff;
			min-width: 200px;
			max-width: 200px;
			position: relative;

			.file-icon {
				width: 48px;
				height: 48px;
				border-radius: 7.5px;
				background: #005252;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;

				svg::v-deep {
					width: 28px;
					height: 28px;

					path {
						fill: white;
					}
				}
			}

			.file-info {
				flex: 1;
				min-width: 0;
				margin-right: 24px;

				.file-name {
					font-family: 'Inter', sans-serif;
					font-size: 14px;
					font-weight: 400;
					color: #131f60;
					line-height: 140%;
					margin-bottom: 2px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.file-type {
					font-family: 'Inter', sans-serif;
					font-size: 10px;
					font-weight: 400;
					color: #131f60;
					line-height: 140%;
					margin-bottom: 2px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
	}
</style>
